import { render, staticRenderFns } from "./WhatsappNotificationsConfig.vue?vue&type=template&id=0038eb9c&scoped=true&lang=pug"
import script from "./WhatsappNotificationsConfig.vue?vue&type=script&lang=js"
export * from "./WhatsappNotificationsConfig.vue?vue&type=script&lang=js"
import style0 from "./WhatsappNotificationsConfig.vue?vue&type=style&index=0&id=0038eb9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0038eb9c",
  null
  
)

export default component.exports